import { use, useMemo } from 'react'
import type { Permission } from '@/shared/api/permissions'
import { AccessContext } from './accessContext'

/** Одно право или «любое из» (`mode: 'all'` — все). Имена — только из перечня `Permission`. */
export type Requirement = Permission | readonly Permission[]

export function useAccess() {
  const { permissions } = use(AccessContext)

  return useMemo(
    () => ({
      can: (perm: Requirement, mode: 'any' | 'all' = 'any'): boolean => {
        const list: readonly Permission[] = typeof perm === 'string' ? [perm] : perm
        return mode === 'all'
          ? list.length > 0 && list.every((item) => permissions.has(item))
          : list.some((item) => permissions.has(item))
      },
    }),
    [permissions],
  )
}
